module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "google.7467d21e.svg";